<sl-select
    #select
    ngDefaultControl 
    [name]="key"
    [placeholder]="props.placeholder || 'Select an option'"
    [clearable]="clearable"
    [label]="props.label | htmlDecode"
    (sl-change)="onSelectionChange($event)"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [disabled]="props.disabled || false"
    [required]="props.required || false"
    [shoelaceReadonly]="props.readonly"
    [hoist]="true">
    <ng-container *ngFor="let option of getOptions(); let i = index">
        <sl-option [id]="id + '_' + i" [value]="option.value">{{ option.label }}</sl-option>
    </ng-container>
    <sl-icon class="large-clear-icon" slot="clear-icon" name="x-lg"></sl-icon>
</sl-select>
